import { MDSTheme, MDSTypography } from '@marqvision/mds/core';
import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(() => ({
  link: {
    textDecoration: 'none',
  },
  text: {
    color: MDSTheme.palette.white,
    transition: 'color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      color: MDSTheme.palette.bluegray[800],
    },
  },
}));

interface IProps {
  color?: string;
  to: string;
  onClick?: (e: any) => void;
}

const FooterLink = ({ to, color, children, onClick }: React.PropsWithChildren<IProps>): JSX.Element => {
  const classes = useStyles();

  return (
    <a href={to} target="_blank" rel="noopener noreferrer" className={classes.link} onClick={onClick}>
      <MDSTypography variant="T16" weight="medium" className={classes.text} style={{ color }}>
        {children}
      </MDSTypography>
    </a>
  );
};

export default FooterLink;
